import { Goal as GoalGraphql, GoalPeriod } from '@akin-home/amplify';
import { Goal, createGoalModel } from '@akin-home/goals';

/** Converts goal grapql response to Goal model */
export const goalGraphqlToModel = (input: GoalGraphql): Goal =>
  createGoalModel({
    id: input.id || '',
    title: input.title,
    emoji: input.emoji || '',
    start: input.start ? new Date(input.start) : undefined,
    habitatID: input.habitatID as string | undefined,
    period: input.period || GoalPeriod.day,
    completions:
      typeof input.completions === 'string'
        ? JSON.parse(input.completions)
        : input.completions || {},
    participant_ids: (input.participantIDS || []) as string[],
    completions_per_period: input.completions_per_period || 1,
    isTemplate: input.isTemplate || false,
    readGroups: (input.readGroups || []) as string[],
    category_ids: (input.category_ids || []) as string[],
    reference_code: input.reference_code || undefined,
    color: input.color || undefined,
  });
